import { ReactElement } from 'react';
export const dateTypeCustomFieldMap = {
    DATE: 'DATE',
    DATE_TIME: 'DATE_TIME'
} as const;
export const customFieldWithAvailableOptionsTypeMap = {
    MULTI_SELECT: 'MULTI_SELECT',
    SELECT: 'SELECT'
} as const;
export const creatableCustomFieldTypeMap = {
    ...customFieldWithAvailableOptionsTypeMap,
    ...dateTypeCustomFieldMap,
    CHECKBOX: 'CHECKBOX',
    MULTI_USER: 'MULTI_USER',
    NUMBER_DECIMAL: 'NUMBER_DECIMAL',
    NUMBER_INTEGER: 'NUMBER_INTEGER',
    TAG: 'TAG',
    TEXT: 'TEXT',
    USER: 'USER'
} as const;
const staticCustomFieldTypeMap = {
    ASSIGNEE: 'ASSIGNEE',
    ATTACHMENTS: 'ATTACHMENTS',
    HTML: 'HTML',
    UNTRUSTED_END_USER: 'UNTRUSTED_END_USER',
    STATUS: 'STATUS',
    FORM: 'FORM'
} as const;
export const customFieldTypeMap = {
    ...creatableCustomFieldTypeMap,
    ...staticCustomFieldTypeMap
};
export const customFieldRequiredTypeMap = {
    NOT_REQUIRED: 'NOT_REQUIRED',
    REQUIRED_TO_SOLVE: 'REQUIRED_TO_SOLVE',
    REQUIRED_TO_SUBMIT: 'REQUIRED_TO_SUBMIT'
} as const;

export const customFieldPermissionTypeMap = {
    AGENT_ONLY: 'AGENT_ONLY',
    EDITABLE_BY_END_USERS: 'EDITABLE_BY_END_USERS',
    END_USER_ONLY: 'END_USER_ONLY', // Only used in end-user forms
    READONLY_FOR_END_USERS: 'READONLY_FOR_END_USERS',
    READONLY: 'READONLY' // Not visible by end-users
} as const;

export const grispiFieldAttributeTypeMap = {
    ALLOWED_NEW_VALUES: 'ALLOWED_NEW_VALUES'
} as const;

export type CreatableCustomFieldType = keyof typeof creatableCustomFieldTypeMap;
export type StaticCustomFieldType = keyof typeof staticCustomFieldTypeMap;
export type CustomFieldType = CreatableCustomFieldType | StaticCustomFieldType;
export type CustomFieldRequiredType = keyof typeof customFieldRequiredTypeMap;
export type CustomFieldPermissionType = keyof typeof customFieldPermissionTypeMap;
export type CustomFieldOptionType = {
    key?: string;
    label: string | ReactElement;
    order: number;
    value: string | number;
};
export type CustomFieldAttributeType = keyof typeof grispiFieldAttributeTypeMap;

export interface CustomField {
    id: number | null;
    key: `ts.${string}` | `tu.${string}` | `ou.${string}` | `uu.${string}` | `du.${string}`;
    name: string;
    description: string | null;
    descriptionForAgents: string;
    descriptionForEndUsers: string;
    titleForAgents: string;
    titleForEndUsers: string;
    required: CustomFieldRequiredType;
    permission: CustomFieldPermissionType;
    attributes: CustomFieldAttributeType[]; // only has value as "[ALLOWED_NEW_VALUES]" for 'SELECT' | 'MULTI_SELECT' | 'TAG' | 'USER' | 'MULTI_USER' | 'UNTRUSTED_END_USER'
    systemField: boolean;
    type: CustomFieldType;
    options: CustomFieldOptionType[]; // only available for 'SELECT' | 'MULTI_SELECT'
}
